export function formatPrice(value: number, currencySymbol: string): string {
    let newValue = `${value}`;
    if (value >= 1000) {
        const suffixes = ["", "k", "m", "b", "t"];
        const suffixNum = Math.floor((`${value}`.length - 1) / 3);
        const shortValue = parseFloat(
            (suffixNum !== 0 ? value / 1000 ** suffixNum : value).toPrecision(2)
        );
        newValue = shortValue + suffixes[suffixNum];
    }
    return `${currencySymbol}${newValue}`;
}
